















































































































import { getSelectCourseList } from "@/api/globalSearch";
import { Prop, Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() disableList!: any[];
  @Prop() originType!: number;
  selectedObject: any = {};
  selectedObjectCache: any = {};
  selectedList: any[] = [];
  selectedListCache: any[] = [];
  dialogVisible = false;
  searchInfo = {
    course_name: "",
  };
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  showDialog() {
    this.selectedObject = { ...this.selectedObjectCache };
    this.selectedList = [...this.selectedListCache];
    this.dialogVisible = true;
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleCancel() {
    this.selectedObject = {};
    this.selectedList = [];
    this.searchInfo.course_name = "";
    this.dialogVisible = false;
  }
  handleConfirm() {
    this.selectedObjectCache = { ...this.selectedObject };
    this.selectedListCache = [...this.selectedList];
    this.dialogVisible = false;
    this.$emit("change", [...this.selectedList]);
  }
  handleCourseSelect(row: any) {
    const copy = { ...this.selectedObject };
    if (copy[row.course_id]) {
      delete copy[row.course_id];
    } else {
      copy[row.course_id] = row;
    }
    this.selectedObject = copy;
    const items = [];
    for (const key in copy) {
      items.push(copy[key]);
    }
    this.selectedList = items;
    const index = this.tableData.findIndex((item: any) => {
      return item.course_id === row.course_id;
    });
    if (index >= 0) {
      this.tableData[index].checked = !!copy[row.course_id];
    }
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
      course_type: this.originType,
    };
    if (this.searchInfo.course_name) {
      option.title = this.searchInfo.course_name;
    }
    getSelectCourseList(option).then((res: any) => {
      const disableIds = this.disableList.map((item: any) => {
        return item.course_id;
      });
      res.data.list.map((item: any) => {
        item.course_type = item.course_type === 1 ? "1vN" : "1v1";
        if (this.selectedObject[item.course_id]) {
          item.checked = true;
        } else {
          item.checked = false;
        }
        if (disableIds.includes(item.course_id)) {
          item.checked = true;
          item.disable = true;
        } else {
          item.disable = false;
        }
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.page = res.data.page;
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
